module.exports = {
   "VisualConfiguration": {
      "@xmlns": {
         "$": "ikea.com/cem/iows/VisualProductConfigurationService/1.0/"
      },
      "ConfigurationSource": {
         "$": ""
      },
      "ContentType": {
         "$": "application/json"
      },
      "Version": {
         "$": "1.0"
      },
      "ConfigurationData": {
         "Content": {
            "$": ""
         },
         "ShoppingBagSectionList": {
            "ShoppingBagSection": {
               "ShoppingBagItemList": {
                  "ShoppingBagItem": [{
                     "ItemType": {
                       "$": ""
                     },
                     "ItemNo": {
                        "$": ""
                     },
                     "ItemQty": {
                        "$": 0
                     },
                     "SortRelevanceList":{}
                  }]
               }
            }
         }
      }
   }
}
;